import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

const useSessionTermsPermissions = getPermissionsHook<'UPDATE_SESSION_TERMS'>({
  entityName: 'session-terms-permissions',
  apiResponseRootKey: 'permissions',
  fetch: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).sessionTermsPermissions.get(),
});

export default useSessionTermsPermissions;
